import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// Create MSAL instance synchronously
export const msalInstance = new PublicClientApplication(msalConfig);

